<div *ngIf="activeCustomer$ | async as customer; else notLoggedIn">
    <a class="btn btn-light text-muted" [routerLink]="['/account']">
        <fa-icon icon="user-circle"></fa-icon>
        <span class="d-none d-sm-inline ml-1">{{ userName(customer) }}</span>
    </a>
</div>
<ng-template #notLoggedIn>
    <a class="btn btn-light text-muted" [routerLink]="['account/sign-in']">
        <fa-icon icon="user-circle"></fa-icon>
        <span class="d-none d-sm-inline ml-1 ">Sign In</span></a>
</ng-template>
